import { render } from "./TopUseCases.vue?vue&type=template&id=2b52cd1e"
import script from "./TopUseCases.vue?vue&type=script&lang=js"
export * from "./TopUseCases.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__